export enum UserSettingsFormFieldNames {
  FirstName = 'firstName',
  LastName = 'lastName',
  EmailAddress = 'emailAddress',
  CityAndState = 'cityAndState',
}
